'use client';

import classNames from 'classnames';
import {
    Facebook as FacebookIcon,
    Linkedin as LinkedinIcon,
    LucideLink as LinkIcon,
    Twitter as TwitterIcon,
    LucideArrowUp as UpIcon,
} from 'lucide-react';
import { useEffect, useState } from 'react';
import { FacebookShareButton, LinkedinShareButton, TwitterShareButton } from 'react-share';

import styles from './AsideFooter.module.scss';

interface Props {
    title: string;
}

const { NEXT_PUBLIC_WEBSITE_URL } = process.env;

export function AsideFooter({ title }: Props) {
    const [shareLink, setShareLink] = useState(NEXT_PUBLIC_WEBSITE_URL);
    const [isBackToTopVisible, setIsBackToTopVisible] = useState(false);

    function handleCopyButtonClick() {
        window.navigator.clipboard.writeText(shareLink);
    }

    function handleScrollToTop() {
        window.scroll({ top: 0, behavior: 'smooth' });
    }

    useEffect(() => {
        setShareLink(window.location.href);
    }, []);

    useEffect(() => {
        function handleScroll() {
            setIsBackToTopVisible(window.scrollY > 200);
        }

        window.addEventListener('scroll', handleScroll, { passive: true });

        return () => {
            window.removeEventListener('scroll', handleScroll);
        };
    }, []);

    return (
        <div
            className={classNames(styles.asideFooter, {
                [styles.withBackToTop]: isBackToTopVisible,
            })}
        >
            <FacebookShareButton className={styles.button} title={title} url={shareLink}>
                <FacebookIcon className={styles.icon} />
            </FacebookShareButton>
            <LinkedinShareButton className={styles.button} title={title} url={shareLink}>
                <LinkedinIcon className={styles.icon} />
            </LinkedinShareButton>
            <TwitterShareButton className={styles.button} title={title} url={shareLink}>
                <TwitterIcon className={styles.icon} />
            </TwitterShareButton>
            <button
                className={styles.button}
                type="button"
                aria-label="Copy"
                onClick={handleCopyButtonClick}
            >
                <LinkIcon className={styles.icon} />
            </button>
            <button
                className={classNames(styles.button, styles.backToTop)}
                type="button"
                aria-label="Back to top"
                tabIndex={isBackToTopVisible ? 0 : -1}
                onClick={handleScrollToTop}
            >
                <UpIcon className={styles.icon} />
            </button>
        </div>
    );
}
